var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"ui-icon",attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","aria-hidden":"true"},domProps:{"innerHTML":_vm._s(_vm.paths[_vm.name] || '')}})
}
var staticRenderFns = []

export { render, staticRenderFns }